// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1788":"3c5774a5","6601":"2d0fd44c"}[chunkId] + ".chunk.css";
};